import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';
import {useracc, postApi, setTitle} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';
import EventEmitter from '../../utils/emmiter';
import EmojiCrew from '../components/emojicrew/emojicrew';

class PortalTemplate extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				status: false,
				id: this.props.service,
				key: '',
				name: '',
				admin: false,
			},
    };
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( getUser );
		const y = await value.setWorker( this.props.service );
		let server = value.worker[this.props.service] || y[this.props.service];
		EventEmitter.emit('/client', {data: 'no value'});

    let params = new URLSearchParams();
		params.append('service', this.props.service);
		const x = await postApi(`${server}/v3/template/portal`, params);
		console.log(x.data);
		if( x.status === 200 ) {
			let service = this.state.service;
			if( service.name !== x.data.servicename || service.status === false ) {
				service.name = x.data.servicename;
				service.key = x.data.servicekey;
				service.admin = x.data.admin
				service.status = true;
				this.setState({service});
				setTitle('EmojiCrew', x.data.servicename);
			}
		}
    
	}
	render() {
		return (
			<>
				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">Stream Template</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								<li className="breadcrumb-item"><Link to={`/${this.state.service.id}`}>{this.state.service.name}</Link></li>
								<li className="breadcrumb-item active" aria-current="page">Dashboard</li>
							</ol>
						</nav>
					</div>
				</div>
				{this.state.service.status === true &&
					<EmojiCrew service={this.props.service} servicekey={this.state.service.key} />
				}
			</>
		);
	}
}

const Template = props => {
  const { service } = useParams();
  return <PortalTemplate service={service} {...props} />
}
export default Template;